<script>
  import { createEventDispatcher } from "svelte"
  import { DEFAULT_FONT_SIZE, toCss } from "./coordinates"

  export let element = null
  export let field
  export let page
  export let placement
  export let scale
  export let selected

  const dispatch = createEventDispatcher()

  // No field means the placement's key no longer exists (a deleted custom
  // field) — style it as an error so it can be found and removed.
  $: css = toCss({ page, placement, scale })
  $: colors = field
    ? `border-sky-500 text-sky-950 ${selected ? "bg-sky-400/40" : "bg-sky-400/20"}`
    : `border-red-500 text-red-900 ${selected ? "bg-red-400/40" : "bg-red-400/20"}`
  $: label = field ? field.qualified_label : placement.key
  $: title = field
    ? `${field.qualified_label} — e.g. ${field.example?.toString() || "no preview value"}`
    : `${placement.key} — this Custom Field no longer exists`
</script>

<div
  bind:this={element}
  class="absolute border cursor-pointer flex items-center overflow-hidden select-none {colors} {selected
    ? 'z-10'
    : ''}"
  data-placement-box={placement.key}
  role="button"
  style="font-size: {(placement.font_size ?? DEFAULT_FONT_SIZE) *
    scale}px; height: {css.height}px; left: {css.left}px; top: {css.top}px; width: {css.width}px;"
  tabindex="-1"
  {title}
  on:pointerdown={() => dispatch("select")}
>
  <span
    class="w-full"
    style="font-family: 'PT Sans', sans-serif; line-height: 1.1; text-align: {placement.align ??
      'left'};"
  >
    {label}
  </span>
</div>
